module.exports = __webpack_public_path__ + "img/mail.9f4900df.svg";